const en = require('./lang_en.json');
const sv = require('./lang_sv.json');

// eslint-disable-next-line import/no-anonymous-default-export
export default { en, sv };
